import React from 'react';

import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers';

import classes from './VideosTable.module.scss';
import { VideoRow } from './VideoRow/VideoRow';
import { EmptyList } from '../../../../../shared/components/ui-components';
import { HeaderRow } from './HeaderRow/HeaderRow';
import { useVideosManagementContext } from '../hooks/useVideosManagement';
import { updateVideosOrder } from './utils/updateVideosOrder';

const VideosTable = () => {
  const { shownVideos: videos, reorderVideos } = useVideosManagementContext();

  return (
    <>
      <div className={classes.videosTable}>
        <HeaderRow />
        <DndContext
          collisionDetection={closestCenter}
          onDragEnd={(event) => updateVideosOrder(event, videos, reorderVideos)}
          modifiers={[restrictToVerticalAxis, restrictToParentElement]}
        >
          <SortableContext
            items={videos.map((video) => video.id)}
            strategy={verticalListSortingStrategy}
          >
            {videos.map((video) => (
              <VideoRow key={video.id} video={video} />
            ))}
          </SortableContext>
        </DndContext>
      </div>
      <EmptyList
        show={videos.length === 0}
        description="There are no videos in this category yet"
      />
    </>
  );
};

export { VideosTable };
